import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  arrowIcon: { alignSelf: 'center', position: 'relative', bottom: UNIT * 0.875 },
  etiquette: {
    textAlign: 'center',
    transform: 'translate(-50%,-100%)',
    position: 'absolute'
  },
  text: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: `1px 1px 5px ${mainColor.colorBlack}`,
    textAlign: 'center',
    borderRadius: UNIT * 0.25,
    padding: UNIT * 0.125,
    minHeight: 25,
    maxWidth: UNIT * 5
  }
});
